export default "__VITE_ASSET__DD9E5xEm__"